// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Z9dX","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__v7tA2"};